import { initMalSiteState } from "../config/initialState";
import { MalSiteActionTypes as ActionTypes, MalSiteState as State,SET_MAL_SITE } from "../types";

export const malSiteReducer = (state = initMalSiteState, action: ActionTypes): State => {
    if (action.type === SET_MAL_SITE) {
        return {
            ...state,
            malSites: action.payload.malSites,
        };
    }
    return state;
}

export default malSiteReducer;